(() => {
  const offer = document.querySelector('#oferta');
  if (!offer) return;

  const get = (selector) => offer.querySelector(selector);
  const books = get('#books');
  const kits = get('#kits');
  const bookStep = get('[data-book-step]');
  const kitStep = get('[data-kit-step]');
  const error = get('[data-offer-error]');
  const slides = [...offer.querySelectorAll('[data-slide]')];
  const choices = [...offer.querySelectorAll('[data-checkout]')];
  const amounts = [0, 9900, 19800, 26730, 33660, 39600];
  const money = (cents) => (cents / 100).toLocaleString('ro-RO', {
    minimumFractionDigits: 2, maximumFractionDigits: 2
  }) + ' lei';
  const quantity = () => Math.max(1, Math.min(10, Math.trunc(Number(kits.value) || 1)));
  let slide = 0;
  let submitting = false;

  function updateTotals() {
    const bookTotal = amounts[Number(books.value)];
    const kitTotal = 14900 * quantity();
    get('[data-book-total]').textContent = money(bookTotal);
    get('[data-kit-total]').textContent = money(kitTotal);
    get('[data-total]').textContent = money(bookTotal + kitTotal);
  }

  function showError(message) {
    error.textContent = message;
    error.hidden = false;
  }

  document.querySelectorAll('[data-open-offer]').forEach((button) => {
    button.addEventListener('click', () => {
      bookStep.hidden = false;
      kitStep.hidden = true;
      error.hidden = true;
      offer.showModal();
      books.focus();
    });
  });
  get('[data-close-offer]').addEventListener('click', () => {
    if (!submitting) offer.close();
  });
  offer.addEventListener('cancel', (event) => {
    if (submitting) event.preventDefault();
  });
  get('[data-next-offer]').addEventListener('click', () => {
    updateTotals();
    bookStep.hidden = true;
    kitStep.hidden = false;
    get('[data-checkout="kit"]').focus();
  });
  get('[data-back-offer]').addEventListener('click', () => {
    if (submitting) return;
    kitStep.hidden = true;
    bookStep.hidden = false;
    error.hidden = true;
    books.focus();
  });
  kits.addEventListener('input', updateTotals);
  kits.addEventListener('change', () => { kits.value = quantity(); updateTotals(); });
  offer.querySelectorAll('[data-step]').forEach((button) => {
    button.addEventListener('click', () => {
      kits.value = Math.max(1, Math.min(10, quantity() + Number(button.dataset.step)));
      updateTotals();
    });
  });
  offer.querySelectorAll('[data-gallery]').forEach((button) => {
    button.addEventListener('click', () => {
      slides[slide].hidden = true;
      slide = (slide + Number(button.dataset.gallery) + slides.length) % slides.length;
      slides[slide].hidden = false;
      get('[data-slide-count]').textContent = `${slide + 1} / ${slides.length}`;
    });
  });
  for (const button of choices) {
    button.addEventListener('click', async () => {
      if (submitting) return;
      error.hidden = true;
      const includeKit = button.dataset.checkout === 'kit';
      if (offer.dataset.available !== 'true' || !offer.dataset.book) {
        showError('Comenzile se vor deschide în curând.');
        return;
      }
      if (includeKit && (offer.dataset.kitAvailable !== 'true' || !offer.dataset.kit)) {
        showError('Kitul nu este disponibil momentan. Poți continua doar cu cartea.');
        return;
      }
      const bookCount = Number(books.value);
      if (bookCount >= 3 && offer.dataset.automaticDiscounts !== 'true') {
        showError('Oferta pentru mai multe exemplare nu este încă disponibilă.');
        return;
      }
      submitting = true;
      choices.forEach((choice) => { choice.disabled = true; });
      const root = offer.dataset.root.replace(/\/?$/, '/');
      const lines = [`${offer.dataset.book}:${bookCount}`];
      if (includeKit) lines.push(`${offer.dataset.kit}:${quantity()}`);
      // A Shopify cart permalink creates the exact set of products for this offer.
      const checkout = new URL(root + 'cart/' + lines.join(','), location.origin);
      checkout.searchParams.set('locale', 'ro');
      try {
        location.assign(checkout.href);
      } catch {
        submitting = false;
        choices.forEach((choice) => { choice.disabled = false; });
        showError('Nu am putut deschide comanda. Încearcă din nou.');
      }
    });
  }
  window.addEventListener('pageshow', () => {
    submitting = false;
    choices.forEach((choice) => { choice.disabled = false; });
  });
})();
